import ApiSetting from '@/request/api/setting'
import axios from '@/request/http'
// import querystring from 'querystring'

const topSwipeApi = {
  list (params) {
    return axios.get(`${ApiSetting.baseUrl}/api/topswipes/`, {params: params})
  },
  detail (topSwipeId, params) {
    return axios.get(`${ApiSetting.baseUrl}/api/topswipes/${topSwipeId}/`, {params: params})
  }
}

export default topSwipeApi
